///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { uniq } from "lodash";

import { shipperRateTypes, shipperRatesMode } from "./types";

export const getShipperRates = shipperRates => {
  const data = [];

  shipperRates.forEach(shipperRate => {
    let rateTypes = [];
    let flatRate = 0;
    let perMileRate = 0;

    shipperRate.rateLineItems.forEach(rateLineItem => {
      if (rateLineItem.chargeCodeId === 1) {
        flatRate += rateLineItem.rate;
      } else if (rateLineItem.chargeCodeId === 3) {
        perMileRate = rateLineItem.rate;
      }
    });

    shipperRate.rateLineItems.forEach(rateLineItem => {
      rateTypes.push(shipperRateTypes[rateLineItem.chargeCodeId]);
    });

    data.push({
      shipperName: shipperRate.shipperName,
      code: shipperRate.shipperCode,
      mode: shipperRatesMode[shipperRate.mode],
      rateType: uniq(rateTypes).join(", "),
      flatRate: flatRate,
      perMileRate: perMileRate,
      effective: shipperRate.effectiveDateUtc,
      expiration: shipperRate.expirationDateUtc,
      metaData: { matched: true }
    });
  });
  data.map((x, index) => (x.metaData.defaultIndex = index));
  return data;
};

export default getShipperRates;
